export default __webpack_public_path__ + "static/media/style16.9fa90f25.png";